import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { classNames } from 'utils/styleUtils';
import dotGridIcon from 'assets/graphics/dot-grid.svg';

const AppSwitcher = (): JSX.Element => {
  const operateLink =
    process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'az'
      ? 'https://app.dataops.live'
      : 'https://app.qa.dataops.live';
  const observeLink =
    process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'az'
      ? 'https://observability.dataops.live'
      : 'https://observability.qa.dataops.live';

  const apps = [
    { name: 'Operate', href: operateLink, openInNewTab: false },
    { name: 'Observe', href: observeLink, openInNewTab: false },
    { name: 'Learn', href: 'https://docs.dataops.live/', openInNewTab: true },
    { name: 'Engage', href: 'https://community.dataops.live/', openInNewTab: true },
  ];

  return (
    <Listbox>
      {({ open }) => (
        <div className="relative pr-5 text-sm text-gray-100 border-r border-secondary-text">
          <Listbox.Button
            className={classNames(
              open ? 'bg-gray-700' : '',
              'relative w-full cursor-pointer flex justify-center rounded-lg hover:bg-gray-700 p-1.5',
            )}
          >
            <img className="w-5 h-5 text-white" src={dotGridIcon} />
          </Listbox.Button>

          <Transition
            show={open}
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 mt-2 max-h-60 w-32 overflow-auto rounded-md bg-dataops-dark text-sm shadow-lg border-[1px] border-dataops-primary-blue">
              {apps.map((app) => (
                <Listbox.Option
                  key={app.name}
                  className={({ active }) =>
                    classNames(
                      active ? 'bg-dataops-secondary-blue text-white' : 'text-gray-100',
                      'relative cursor-default select-none py-2 pl-3 pr-9',
                    )
                  }
                  value={app}
                >
                  <a
                    href={app.href}
                    target={app.openInNewTab ? '_blank' : '_self'}
                    rel="noreferrer"
                    className="block truncate font-normal"
                  >
                    {app.name}
                  </a>
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
};

export default AppSwitcher;
